/**
 * MSAL Configuration for Azure AD Authentication
 * 
 * This configuration sets up MSAL.js v3 for Auth Code + PKCE flow
 * with proper scopes and redirect handling.
 */

import { LogLevel } from "@azure/msal-browser";

// Environment configuration
const TENANT_ID = process.env.REACT_APP_AZURE_TENANT_ID || "9137d560-025b-4fb0-a237-46945bbefc42";
const CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID || "6ff2aed4-74d5-4da6-9b7f-0c53127e7aa0";
const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI || window.location.origin;

/**
 * MSAL Configuration Object
 */
export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: REDIRECT_URI,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage", // Use localStorage for persistence
    storeAuthStateInCookie: false, // Set to true for IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

/**
 * Scopes for API access
 */
export const loginRequest = {
  scopes: [
    "openid",
    "profile", 
    "email",
    "User.Read"
  ],
  prompt: "select_account",
};

/**
 * Scopes for API calls
 * Request ID token with user profile claims instead of access token for Graph API
 */
export const apiRequest = {
  scopes: [
    "openid",
    "profile",
    "email"
  ],
};

/**
 * Graph API scopes (if needed)
 */
export const graphRequest = {
  scopes: ["User.Read"],
};

/**
 * Protected resources configuration
 */
export const protectedResources = {
  api: {
    endpoint: "/api",
    scopes: [
      "openid",
      "profile", 
      "email",
      "User.Read"
    ],
  },
  graphMe: {
    endpoint: "https://graph.microsoft.com/v1.0/me",
    scopes: ["User.Read"],
  },
}; 